import React from 'react';
import { CALLOUT_COLUMN_COUNTS } from '../../../utils/calloutColumns';

const ColumnsIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
    <rect x="3" y="4" width="5" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="10" y="4" width="5" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="17" y="4" width="5" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const CopiedIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M5 13L9 17L19 7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CopyIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
    <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

/**
 * Sticky Copy chip plus the 1–6 columns picker. Shown on filled callouts only.
 */
export const CalloutToolbar = ({
  columnsRef,
  columnsOpen,
  setColumnsOpen,
  columnCount,
  applyColumns,
  copied,
  onCopy,
}) => (
  <div className="callout-copy-rail">
    <div
      ref={columnsRef}
      className={`callout-columns${columnsOpen ? ' callout-columns--open' : ''}`}
    >
      <button
        type="button"
        className={`callout-copy callout-columns-btn${columnsOpen ? ' callout-copy--active' : ''}${columnCount > 1 ? ' callout-columns-btn--on' : ''}`}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          setColumnsOpen((open) => !open);
        }}
        onContextMenu={(e) => e.stopPropagation()}
        title={columnCount > 1 ? `Columns on (${columnCount})` : 'Columns'}
        aria-label="Keep section in even columns"
        aria-expanded={columnsOpen}
        aria-haspopup="menu"
      >
        <ColumnsIcon />
      </button>
      {columnsOpen ? (
        <div className="callout-columns-picker" role="menu" aria-label="Column count">
          {CALLOUT_COLUMN_COUNTS.map((n) => (
            <button
              key={n}
              type="button"
              role="menuitemradio"
              aria-checked={columnCount === n}
              className={`callout-columns-picker__btn${columnCount === n ? ' is-active' : ''}`}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                applyColumns(n);
              }}
              title={`${n} column${n === 1 ? '' : 's'}`}
            >
              {n}
            </button>
          ))}
        </div>
      ) : null}
    </div>
    <button
      type="button"
      className={`callout-copy${copied ? ' callout-copy--active' : ''}`}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={onCopy}
      onContextMenu={(e) => e.stopPropagation()}
      title="Copy"
      aria-label="Copy section"
    >
      {copied ? <CopiedIcon /> : <CopyIcon />}
      <span>{copied ? 'Copied' : 'Copy'}</span>
    </button>
  </div>
);
